/* eslint-disable react/destructuring-assignment, react/no-unused-state, sort-keys */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { debounce, throttle } from 'lodash';

import { Button, Icon, Input } from 'semantic-ui-react';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import { ASSIGNMENT_MENU_STATUS } from '../managers/AssignmentManager';
import { VIEW_SELECTION } from '../managers/NavigationManager';

import { setDocumentTitleFromSelectionView } from '../utils';

export default
@inject('assignmentManager')
@observer
class AssignmentMenu extends Component {
  debouncedSearch = debounce(async (menuStatus, search, sort) => {
    await this.resetSearch(menuStatus, search, sort);
    const { assignmentManager } = this.props;
    if (assignmentManager.loadingStudentAssignmentMenu) {
      assignmentManager.setLoadingStudentAssignmentMenu(false);
    }
  }, 500);

  throttledSearch = throttle(async (menuStatus, search, sort) => {
    await this.resetSearch(menuStatus, search, sort);
    const { assignmentManager } = this.props;
    if (assignmentManager.loadingStudentAssignmentMenu) {
      assignmentManager.setLoadingStudentAssignmentMenu(false);
    }
  }, 3000);

  constructor(props) {
    super(props);

    const { menuStatus, sort, search, t } = this.props;

    this.StudentAssignmentMenuStatusTabs = SatCoreComponent('StudentAssignmentMenuStatusTabs');

    this.state = {
      menuStatus: (menuStatus) || ASSIGNMENT_MENU_STATUS.CURRENT,
      sort: (sort) || 'asc',
      search: (search) || '',
      buttonIcon: (sort === 'desc') ? 'up arrow' : 'down arrow',
      buttonLabel: (sort === 'desc') ? 'Sort: Last' : 'Sort: First',
      titleName: t(ASSIGNMENT_MENU_STATUS.getTitle(
        (menuStatus) || ASSIGNMENT_MENU_STATUS.CURRENT
      ), 'Missing translation in AssignmentMenu')
    };
  }

  async componentDidMount() {
    const { assignmentManager } = this.props;
    await this.resetSearch(this.state.menuStatus, this.state.search, this.state.sort);
    assignmentManager.setCurrentAssignmentMenu(this.state.menuStatus);
  }

  componentDidUpdate() {
    const { t } = this.props;
    const { menuStatus } = this.state;
    const docSuffix = `docSuffix${ASSIGNMENT_MENU_STATUS.getTitle(menuStatus)}`;
    setDocumentTitleFromSelectionView(VIEW_SELECTION.ASSIGNMENTS, {
      VIEW_SELECTION,
      suffix: t(docSuffix)
    });
  }

  resetSearch = async (menuStatus, search, sort) => {
    await this.fetchSearch(menuStatus, search, sort);
  }

  fetchSearch = async (menuStatus, search, sort) => {
    await this.props.fetchAssignments(menuStatus, search, sort);
  }

  handleChangeSearch = async (_event, { value }) => {
    if (value.length > 2 || value.length === 0) {
      const { state } = this;
      this.debouncedSearch(state.menuStatus, value, state.sort);
    }
    this.setState({ search: value });
  }

  handleChangeStatusMenu = async (_event, { name }) => {
    const { assignmentManager, t } = this.props;

    if (assignmentManager.loadingStudentAssignmentMenu) {
      return;
    }
    const { state } = this;

    assignmentManager.setLoadingStudentAssignmentMenu(true);
    assignmentManager.clearAssignments();

    const title = t(ASSIGNMENT_MENU_STATUS.getTitle(name),
      'Missing translation in AssignmentMenu'
    );
    this.setState({ menuStatus: name, titleName: title });
    assignmentManager.setCurrentAssignmentMenu(name);

    this.throttledSearch(name, state.search, state.sort);
  }

  handleChangeSort = async () => {
    const { sort, menuStatus, search } = this.state;
    if (sort === 'asc') {
      this.setState({ sort: 'desc', buttonIcon: 'up arrow', buttonLabel: 'Sort: Last' });
      await this.resetSearch(menuStatus, search, 'desc');
    } else {
      this.setState({ sort: 'asc', buttonIcon: 'down arrow', buttonLabel: 'Sort: First' });
      await this.resetSearch(menuStatus, search, 'asc');
    }
  }

  render() {
    const { assignmentManager, t } = this.props;

    const { loadingStudentAssignmentMenu } = assignmentManager;

    // TODO remove // const { menuStatus } = this.props;
    const { buttonLabel, buttonIcon, menuStatus, search } = this.state;

    const { StudentAssignmentMenuStatusTabs } = this;

    const ariaLabelMenuStatus = menuStatus ? t(`aria${ASSIGNMENT_MENU_STATUS.getTitle(menuStatus)}`) : '';

    return (
      <>
        <div className='sa-header-row sa-header-row-img'>
          <h1 className='sa-header-label page-heading'>{t('AssignmentLabel', 'Missing assignment label translation')}</h1>
          <StudentAssignmentMenuStatusTabs
            activeMenuStatus={menuStatus}
            idPrefix='assignment-menu'
            loading={loadingStudentAssignmentMenu}
            loadingClassName='loading-student-assignment-menu'
            onClick={this.handleChangeStatusMenu}
            tabPanelId='assignment-menu-panel' />
        </div>

        <div className='sa-second-header-row'>
          <h2
            aria-label={ariaLabelMenuStatus}
            className='sa-second-header-label aria-offscreen-relative'>
            {/* Visually hidden per DEMO-1713, but kept as h2 per C2C-7819 to provide proper heading hierarchy */}
            {ariaLabelMenuStatus}
          </h2>
          <div className='sa-search-n-sort'>
            <Button icon labelPosition='right' onClick={this.handleChangeSort}>
              {buttonLabel}
              <Icon name={buttonIcon} />
            </Button>
            <Input
              aria-label={t('searchContentAriaLabel')}
              className='search-input student-assignment-search-input'
              icon='search'
              label={{ content: t('searchContentLabel'), basic: true }}
              labelPosition='left'
              name='search'
              onChange={this.handleChangeSearch}
              placeholder={t('SearchPlaceholder', 'No placeholder translation')}
              type='text'
              value={search} />
          </div>
        </div>
      </>
    );
  }
}

SatCoreRegister('AssignmentMenu', AssignmentMenu);
